<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
        </section>
        <main class="wrapper-404">
            <div class="error-404">
              <h1>
              服务器<span style="color: red">BOOM!BOOM!BOOM</span>~程序员努力抢修中...
              </h1>
                <div class="moon"><span>5</span><span><img class="icon has-animation" src="https://image.flaticon.com/icons/svg/179/179595.svg" alt=""/></span><span><img class="icon has-animation" src="https://image.flaticon.com/icons/svg/179/179595.svg" alt=""/></span></div>
                 </div>
        </main>
    </div>
</template>
<script>
export default {
  name: 'NotFound'
}
</script>



// WEBPACK FOOTER //
// 500.vue?279cc1aa